import RailsResource from './rails-resource';

export default new class ActionReporterService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'action_reports',
      ajaxLoader: false
    });
  }

  reportAction(reportable_type, reportable_id, action, sub_action) {
    return this.post(`${this.url}/${reportable_type}/${reportable_id}/action_reports`, true, {
      action_report: {
        action: action,
        sub_action: sub_action
      }
    });
  }

  endAction(reportable_type, reportable_id, action_id) {
    return this.post(`${this.url}/${reportable_type}/${reportable_id}/action_reports/${action_id}/end`, true);
  }
}
